<template>
  <div ref="box">
    <el-carousel indicator-position="outside" class="carousel" :height="height || '150px'" v-if="boxWidth">
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <div class="item-box">
          <ul class="component-image-carousel-ul">
            <slot :list="item"></slot>
          </ul>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<style lang="scss">
  .item-box{
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
  }
  .component-image-carousel-ul{
    height:100%;
    >li{
      float:left;
    }
    .match-face-list-li {
      .pa {
        right: -10px;
      }
      .el-checkbox__inner {
        width: 20px;
        height: 20px;
      }
      .el-checkbox__inner::after {
        width: 5px;
        height: 12px;
        left: 6px;
      }
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/image-carousel/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/image-carousel/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/image-carousel/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-image-carousel')
  export default {
    name: 'base-image-carousel', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-image-carousel': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>